var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 59,
  height: 42,
  viewBox: "0 0 59 42",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5.99 32A4.005 4.005 0 0 1 10 36.01v1.98A4.005 4.005 0 0 1 5.99 42H4.01A4.005 4.005 0 0 1 0 37.99v-1.98A4.005 4.005 0 0 1 4.01 32zM59 33v8H17v-8zM5.99 16A4.005 4.005 0 0 1 10 20.01v1.98A4.005 4.005 0 0 1 5.99 26H4.01A4.005 4.005 0 0 1 0 21.99v-1.98A4.005 4.005 0 0 1 4.01 16zM59 17v8H17v-8zM5.99 0A4.005 4.005 0 0 1 10 4.01v1.98A4.005 4.005 0 0 1 5.99 10H4.01A4.005 4.005 0 0 1 0 5.99V4.01A4.005 4.005 0 0 1 4.01 0zM59 1v8H17V1z"
})));
export default SvgChannelList;